export function todayStr(d: Date = new Date()): string {
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - off).toISOString().slice(0, 10);
}
export function nowISO(): string {
  return new Date().toISOString();
}
export function fmtHM(iso: string): string {
  return new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}
export function fmtDateBR(dateStr: string): string {
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
}

export function applyTemplate(text: string, emp: Record<string, any>): string {
  if (!text) return '';
  const map: Record<string, string> = {
    nome: emp.nome || '',
    cpf: emp.cpf || '',
    pis: emp.pis || '',
    endereco: emp.endereco || '',
    telefone: emp.telefone || '',
    pix: emp.pix || '',
    funcao: emp.funcao || '',
    camarote: emp.camarote || '',
    valor_hora: emp.valorHora || '',
    data: fmtDateBR(todayStr()),
  };
  return text.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (m, k) => (k.toLowerCase() in map ? map[k.toLowerCase()] : m));
}
